import React from 'react' 
import { Route, Switch } from 'react-router-dom'

import Auth from 'pages/Auth'
import Home from 'pages/Home'
import TankRegistration from 'pages/TankRegistration'
import TankSearch from 'pages/TankSearch'
import Settings from 'pages/Settings'
import Tank from 'pages/Tank'
import _404 from 'pages/404'
import _403 from 'pages/403'
import authenticator from 'utils/authenticator'

const App = (): JSX.Element => (
  <Switch>
    <Route exact path="/" component={authenticator(Home)} />
    <Route exact path="/auth" component={authenticator(Auth)} />
    <Route exact path="/register" component={authenticator(TankRegistration)} />
    <Route exact path="/search" component={authenticator(TankSearch)} />
    <Route exact path="/settings/:tankId" component={authenticator(Settings)} />
    <Route exact path="/tank/:tankId" component={authenticator(Tank)} />
    <Route exact path="/403" component={authenticator(_403)} />
    <Route component={_404} />
  </Switch>
)
export default App
